
import { Options, Vue } from "vue-class-component";
import address from "@/variable";
import axios from "axios";
import { useStore } from "vuex";

@Options({
  components: {},
})
export default class Form extends Vue {
  doc: any = {};
  rooms: Array<any> = []
  store = useStore();
  updateAmount(){
    this.doc.amount = parseFloat(((this.doc.length??0)*(this.doc.rate??0)).toFixed(2))
  }
  mounted() {
    axios.get(`${address}/code-by-field/name/Accommodation Room`).then((response) => {
      this.rooms = response.data.member;
    });
    if (this.$route.params.id != undefined) this.fetchData();
    if (this.$route.query.room != undefined) this.doc.room = this.$route.query.room
  }
  fetchData() {
    axios.get(`${address}/accommodation/${this.$route.params.id}`).then((response) => {
      this.doc = response.data;
    });
  }
  push(field:string) {    if(this.doc[field] == undefined) this.doc[field] = []
    this.doc[field].push({})
  }
  submitForm() {
    if (this.$route.params.id != undefined) {
      axios
        .patch(`${address}/accommodation/${this.doc._id}`, this.doc)
        .then((response) => {
          alert("แก้ไขข้อมูลแล้ว");
          this.$router.push("/accommodation");
        });
    } else {
      axios
        .post(`${address}/accommodation`, {
          ...this.doc,
        })
        .then((response) => {
          alert("บันทึกข้อมูลแล้ว");
          this.$router.push("/accommodation");
        });
    }
  }
}
